<template>
  <section>
    <Banner value="Campanhas"/>

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p
              class="lead"
            >No sentido de conscientizar estudantes e promover boas ações voltadas para a construção de uma sociedade mais sustentável a Escola Engenho busca promover campanhas sociais e ecológicas.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <v-container grid-list-lg>
      <v-layout row wrap my-4>
        <v-flex xs12>
          <p style="text-align:center !important;">
            <small>Clique em uma das campanhas para ampliar</small>
          </p>
        </v-flex>
        <VueGallery :images="$store.getters.campanhas(true)" :index="index" @close="index = null"></VueGallery>
        <v-flex v-for="(image, i) in $store.getters.campanhas()" :key="i" xs6 sm6 md4 lg3 xl3>
          <v-hover>
            <v-card
              flat
              tile
              class="d-flex"
              slot-scope="{ hover }"
              @click="index = i"
              :class="`elevation-${hover ? 12 : 2}`"
            >
              <v-img :src="image" class="grey lighten-2">
                <template v-slot:placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="blue lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueGallery from "vue-gallery";
import Banner from "../../components/Banner";

export default {
  data: () => ({
    index: null
  }),
  components: {
    Banner,
    VueGallery
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  cursor: pointer;
}

p,
h2 {
  text-align: justify !important;
}
</style>

